import { render, staticRenderFns } from "./PermohonanPemerintah.vue?vue&type=template&id=58d29bab&"
import script from "./PermohonanPemerintah.vue?vue&type=script&lang=js&"
export * from "./PermohonanPemerintah.vue?vue&type=script&lang=js&"
import style0 from "./PermohonanPemerintah.vue?vue&type=style&index=0&id=58d29bab&prod&lang=css&"
import style1 from "./Elements.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports